module.exports = __webpack_public_path__ + "img/CreekRoadWestVineSign_HRZ_Mobile.2b00ce22.png";